import { STALE_AFTER_DAYS } from "./statistics";

const MINUTE = 60;
const HOUR = 3600;
const DAY = 86400;

const plural = (count, noun) => `${count} ${noun}${count === 1 ? "" : "s"} ago`;

// Своя реализация вместо библиотеки: новые npm-зависимости в этом форке
// запрещены — образ на node 12 / npm 6 с закоммиченным локом, и обновление
// лока это ручная процедура.
export const formatRelativeTime = (timestampSeconds, nowSeconds) => {
  if (typeof timestampSeconds !== "number") {
    return null;
  }
  // Часы клиента и сервера расходятся, и отрицательная разница дала бы
  // «-1 minutes ago». Будущее показываем как «только что».
  const elapsed = Math.max(0, nowSeconds - timestampSeconds);
  if (elapsed < MINUTE) {
    return "just now";
  }
  if (elapsed < HOUR) {
    return plural(Math.floor(elapsed / MINUTE), "minute");
  }
  if (elapsed < DAY) {
    return plural(Math.floor(elapsed / HOUR), "hour");
  }
  return plural(Math.floor(elapsed / DAY), "day");
};

export const isStale = (timestampSeconds, nowSeconds) => {
  if (typeof timestampSeconds !== "number") {
    return false;
  }
  return nowSeconds - timestampSeconds > STALE_AFTER_DAYS * DAY;
};
